<template>
  <div class="plk_styles row">
    <Menu></Menu>
    <div class="styles">
      <select class="u-full-width" v-model="showOption">
        <option :value="styleOption">{{$t('designer.styles.styleOption')}}</option>
        <option :value="colorsOption">{{$t('designer.styles.colorsOption')}}</option>
      </select>
      <codemirror v-if="showStyle" v-model="styles" :options="cmOptions" />
      <codemirror v-if="showColors" v-model="colors" :options="cmOptions" />
    </div>
  </div>
</template>

<script>
import i18n from './i18n'
import { codemirror } from 'vue-codemirror'
import Menu from './components/Menu/Menu'
import 'codemirror/lib/codemirror.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/elegant.css'
import { DESIGN } from '@/store'
const OPTION_STYLE = 'styles'
const OPTION_COLORS = 'colors'

export default {
  name: 'styles',
  components: {
    codemirror,
    Menu
  },
  data () {
    return {
      styleOption: OPTION_STYLE,
      colorsOption: OPTION_COLORS,
      showOption: OPTION_STYLE,
      cmOptions: {
        tabSize: 2,
        autoCloseTags: true,
        mode: 'text/css',
        theme: 'elegant',
        lineNumbers: true,
        styleActiveLine: true,
        line: true,
        matchBrackets: true
      }
    }
  },
  computed: {
    showStyle () {
      return this.showOption === OPTION_STYLE
    },
    showColors () {
      return this.showOption === OPTION_COLORS
    },
    styles: {
      get: function () {
        return this.$store.getters[DESIGN.GETTERS.GET_STYLE]()
      },
      set: function (styles) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.SET_STYLE,
          code: styles
        })
      }
    },
    colors: {
      get: function () {
        return this.$store.getters[DESIGN.GETTERS.GET_COLORS]()
      },
      set: function (styles) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.SET_COLORS,
          code: styles
        })
      }
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    }
  }
}
</script>
<style lang="scss">
  .plk_styles {
    .CodeMirror {
      border: 1px solid #dee2e6;
      height: 93vh;
    }
  }
</style>
<style scoped lang="scss">
  .plk_styles {
    background: #f8f9fa;

    .styles {
      padding: 3vh;
      padding-left: calc(3vh + 50px);
    }
    .menu_components {
      padding: 5px;
      background: #848e98;
      height: 100vh;
      overflow: scroll;
      border-right: solid 1px #dee2e6;
    }
  }
</style>
